import React from 'react';
import api from './api';
import { Alert, Snackbar } from '@mui/material';

class ApiService {
  static TIMEOUT = 100000; // 10 segundos de timeout

  static handleApiError = (error) => {
    if (error.response) {
      console.error('Error de respuesta:', error.response.data);
      console.error('Código de estado:', error.response.status);
      throw new Error(`Error ${error.response.status}: ${error.response.data.message || 'Ocurrió un error en el servidor'}`);
    } else if (error.request) {
      console.error('Error de solicitud:', error.request);
      throw new Error('No se recibió respuesta del servidor. Por favor, intente más tarde.');
    } else {
      console.error('Error:', error.message);
      throw new Error('Ocurrió un error al procesar la solicitud. Por favor, intente de nuevo.');
    }
  };

  static withTimeout = (promise) => {
    return Promise.race([
      promise,
      new Promise((_, reject) =>
        setTimeout(() => reject(new Error('La solicitud ha excedido el tiempo de espera')), this.TIMEOUT)
      )
    ]);
  };

  static async makeRequest(method, url, data = null, successMessage = 'Operación exitosa') {
    try {
      const response = await this.withTimeout(api[method](url, data));
      this.showNotification(successMessage, 'success');
      return response.data;
    } catch (error) {
      this.handleApiError(error);
    }
  }

  static get(url, successMessage) {
    return this.makeRequest('get', url, null, successMessage);
  }

  static post(url, data, successMessage) {
    return this.makeRequest('post', url, data, successMessage);
  }

  static put(url, data, successMessage) {
    return this.makeRequest('put', url, data, successMessage);
  }

  static delete(url, successMessage) {
    return this.makeRequest('delete', url, null, successMessage);
  }

  static showNotification(message, severity = 'success') {
    // Este método debe ser implementado en un componente React
    // que maneje el estado global de las notificaciones
    if (window.showGlobalNotification) {
      window.showGlobalNotification(message, severity);
    } else {
      console.warm(`Notification (${severity}): ${message}`);
    }
  }
}

// Componente para manejar notificaciones globales
const NotificationHandler = () => {
  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const [severity, setSeverity] = React.useState('success');

  React.useEffect(() => {
    window.showGlobalNotification = (msg, sev) => {
      setMessage(msg);
      setSeverity(sev);
      setOpen(true);
    };
  }, []);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  return (
    <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
      <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export { ApiService, NotificationHandler };